import Home from './pages/home'
import About from './pages/about'
import Products from './pages/products'
import Projects from './pages/projects'
import Blogs from './pages/blogs'
import Contact from './pages/contact'
import TopNav from './component/TopNav';
import Footer from './component/footer'
import { BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import Solution from './pages/solution';
import Problem from './pages/problem';
import './App.css';

function App() {
  return (
    <Router>
    <div className="App">
      <TopNav />
        <div className="content">
          <Switch>
            <Route exact path="/" component={Home}>
              <Home />
            </Route>
            <Route path="/about" component={About}>
              <About />
            </Route>
            <Route path="/solution" component={Solution}>
              <Solution />
            </Route>
            <Route path="/problem" component={Problem}>
              <Problem />
            </Route>
            <Route path="/products" component={Products}>
              <Products />
            </Route>
            <Route path="/projects" component={Projects}>
              <Projects />
            </Route>
            <Route path="/blogs" component={Blogs}>
              <Blogs />
            </Route>
            <Route path="/contact" component={Contact}>
              <Contact />
            </Route>
          </Switch>
        </div>
      <Footer />
    </div>
    </Router>
  );
}

export default App;
